export const TOKEN_AUTH_USERNAME = 'testlfmclientid';
export const TOKEN_AUTH_PASSWORD = 'ZkK9HEZB0CaMGPgg';
export const TOKEN_NAME = 'access_token';
